export default __webpack_public_path__ + "static/media/icone-cadastros.522b7abb.svg";